export default __webpack_public_path__ + "static/media/_1208766.f97127c2.webp";